module.exports = __webpack_public_path__ + "img/red_070.0d3e3db3.png";